import { BaseService } from 'core/services';
import PatientNumberRouteService from './PatientNumberRouteService';

class PatientNumberService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new PatientNumberRouteService());
    }

}

export default PatientNumberService;
